import { useEffect, useState } from 'react';
import { useDebounce, DEFAULT_DELAY } from '../../Hooks/useDebounce';
import './debounced-input.scss';
import BizInput from './BizInput';
import { BizControlSize } from '../../Types/controlSize';

type DebouncedInputProps = {
	size?: BizControlSize;
	onChange: (value: string) => void;
	value?: string;
	delay?: number;
	placeholder?: string;
	className?: string;
	iconStart?: string;
	iconEnd?: string;
	clearable?: boolean;
	clearLabel?: string;
};

const DebouncedInput = ({
	onChange,
	value: pValue,
	placeholder,
	className,
	delay = DEFAULT_DELAY,
	iconStart,
	iconEnd,
	size,
	clearable,
	clearLabel,
}: DebouncedInputProps) => {
	const [value, setValue] = useState(pValue ?? '');
	const debouncedValue = useDebounce(value, delay);

	useEffect(() => {
		setValue(pValue ?? '');
	}, [pValue]);

	useEffect(() => {
		onChange(value);
	}, [debouncedValue]);

	const showStartIcon = iconStart !== undefined;

	return (
		<div
			className={`biz-debounced-input${showStartIcon ? ' has-start-icon' : ''}${iconEnd !== undefined ? ' has-end-icon' : ''}`}
		>
			{showStartIcon && (
				<div className='icon-start-wrapper'>
					<i className={iconStart} />
				</div>
			)}
			<BizInput
				size={size}
				type='text'
				className={className}
				placeholder={placeholder}
				value={value}
				clearable={clearable}
				clearLabel={clearLabel}
				onChange={(e) => setValue(e.target.value)}
			/>
			{iconEnd !== undefined && (
				<div className='icon-end-wrapper'>
					<i className={iconEnd} />
				</div>
			)}
		</div>
	);
};

export default DebouncedInput;
